/**
 *
 * This tiny utility method helps to make our codebase have 1 type of unknown value: undefined.
 */
export const convertNullToUndefined = (value: null | string | undefined) => (value === null ? undefined : value);
